// biome-ignore lint/style/noRestrictedImports: persist needs the auth reducer key
import { AUTH_REDUCER_KEY } from 'app-components/flux/auth';

import { type Config, defaultGetCacheKey } from './config';

export function clearCachedState(
  { stateKeys, storageInterface, getCacheKeyForStateKey = defaultGetCacheKey }: Config,
  options?: { keepAuthStore: boolean },
) {
  const tasks: Array<Promise<any>> = [];

  for (const key of stateKeys) {
    if (!(key === AUTH_REDUCER_KEY && options?.keepAuthStore)) {
      tasks.push(storageInterface.removeItem(getCacheKeyForStateKey(key)));
    }
  }

  return Promise.all(tasks);
}
